import React, { useState, useContext, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import LeftMenu from "./LeftMenu.jsx";
import RightMenu from "./RightMenu";
import { Drawer, Button } from "antd";
import Clock from "react-live-clock";
import PrivilegeContext from "../context/privilege";
import { PermissionContext } from "../../context/permissionContext";
import { loadPermission } from "../../services/authService";
import BranchContext from "./../context/branch";

import Selectbranch from "./../common/selectBranch";
import auth from "../../services/authService";
import { GetBranch } from "../../services/authService";
import useWindowDimensions from "../common/usewindowsdimensions";
import _ from "lodash";

// class Navbar extends Component {
// 	state = {
// 		current: 'mail',
// 		visible: false
// 	}
// 	showDrawer = () => {
// 		this.setState({
// 			visible: true,
// 		});
// 	};

// 	onClose = () => {
// 		this.setState({
// 			visible: false,
// 		});
// 	};
const Navbar = ({ loading }) => {
  const currentBranch = useContext(BranchContext);

  const { permission } = useContext(PermissionContext);
  const [menulist, setmenulist] = useState([]);
  const [user, setuser] = useState({ empid: "" });
  const history = useHistory();

  const { width } = useWindowDimensions();
  // const user =  auth.getCurrentUser();

  useEffect(() => {
    const loadData = async () => {
      const result = await auth.getCurrentUser2();
      if (result) {
        setuser(result);
      }
    };
    loadData();
  }, []);

  const user1 = auth.getCurrentUser();

  if (user1 && user.empid === "") {
    setuser(user1);
  }

  const [branchList, setbrachList] = useState([]);
  const [stateData, setstateData] = useState({
    askConfirm: { enable: false, message: "" },
    message: [],
  });

  const [formload, setformload] = useState(false);
  const [isSmall, setisSmall] = useState(false);
  const [isPrivileged, setisPrivileged] = useState(true);

  useEffect(() => {
    if (!formload) return;
    const setLayout = () => {
      if (width >= 1024) {
        setisSmall(false);
      } else {
        setisSmall(true);
      }
    };
    setLayout();
  }, [width, formload]);

  useEffect(() => {

    if (!user.empid) return;

    const loadData = async () => {
      const { data: result } = await GetBranch();

      setformload(true);

      if (result.status === "success") {
        setbrachList(result.data.list);
      } else {
        setbrachList([]);
      }
    };
    loadData();
  }, [user.empid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!branchList) return;
    if (branchList.length === 0) return;

    const loadDefault = () => {
      const privilegebranchid = _.find(branchList, function (o) {
        return o._id === currentBranch.currentBranch._id;
      });
      if (currentBranch && currentBranch.currentBranch._id == null && user) {
        // check
        setstateData({ askConfirm: { enable: true, message: "" } });
      } else if (currentBranch && user && !privilegebranchid) {
        setisPrivileged(false);
        setstateData({ askConfirm: { enable: true, message: "" } });
      }
    };
    loadDefault();
  }, [user, currentBranch, branchList]);

  const handleCancleSubmit = () => {
    if (isPrivileged) {
      setstateData({ askConfirm: { enable: false, message: "" } });
    }
  };

  const handleConfirmSubmit = (e) => {
    setisPrivileged(true);
    const { name, value } = e.currentTarget;
    setstateData({ askConfirm: { enable: false, message: "" } });

    const objClone = {
      _id: name,
      name: value,
    };
    auth.setCurrentBranchID(objClone._id);
    auth.setCurrentBranchName(objClone.name);
    currentBranch.onSelected(objClone);
  };
  const handleonClick = () => {
    setstateData({ askConfirm: { enable: true, message: "" } });
  };

  useEffect(() => {
    if (!currentBranch) return;
    if (
      currentBranch.currentBranch._id === "0" ||
      currentBranch.currentBranch._id === ""
    )
      return;

      if (!user.empid) return;
    const getPermission = async () => {
      const result = await loadPermission();

      if (result) {
        if (result.status === "success") {
          setmenulist(result.data.menuItems);
        } else if (result.status === "error") {
          history.replace("/logout");
        }
      }
    };
    getPermission();
  }, [currentBranch,user,currentBranch]);



  const [state, setState] = useState({ current: "mail", visible: false });
  // const [isopen, setisopen] = useState(false);
  const showDrawer = () => {
    // setisopen(true);
    setState({ ...state, visible: true });
    // 		this.setState({
    // 			visible: true,
    // 		});
  };
  const onClose = () => {
    // setisopen(false);
    setState({ ...state, visible: false });
  };
  const handleOnClick = () => {
    setState({ ...state, visible: false });
  };
  //  console.log("user",user1,user)
  return (
    <nav className="menuBar">
      <div className="logo mt-2">
        {currentBranch.currentBranch &&
        (currentBranch.currentBranch._id === "" ||
          currentBranch.currentBranch._id == null) ? (
          <Selectbranch
            isOpen={stateData.askConfirm.enable}
            onConfirm={handleConfirmSubmit}
            onCancel={handleCancleSubmit}
            list={branchList}
            onSelected={handleConfirmSubmit}
          />
        ) : (
          <Selectbranch
            isOpen={stateData.askConfirm.enable}
            onConfirm={handleConfirmSubmit}
            onCancel={handleCancleSubmit}
            list={branchList}
            onSelected={handleConfirmSubmit}
          />
        )}
        {user1 && (
          <button
            type="button"
            onClick={handleonClick}
            className="btn btn-dark text-warning"
          >
            {currentBranch.currentBranch && isSmall
              ? currentBranch.currentBranch._id
              : currentBranch.currentBranch
              ? currentBranch.currentBranch.name
              : "Plese Select"}{" "}
          </button>
        )}{" "}
        WMS
        {user && (
          <div className="d-none d-md-inline text-white text-muted">
            {user.empid ? (
              <img
                src={
                  "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=" +
                  user.empid +
                  "&size=320"
                }
                className="rounded-circle ms-2 me-4"
                data-toggle="tooltip"
                data-placement="bottom"
                title=""
                alt=""
                style={{
                  maxHeight: "50px",
                  Width: "100%",
                  maxWidth: "30px",
                }}
              ></img>
            ) : null}
          </div>
        )}
        {user && (
          <>
            <strong
              className="d-none d-xl-inline ms-2 "
              style={{ fontSize: "14px" }}
            >
              <Clock format="ddd" ticking={true} interval={60000} />
            </strong>
            <strong
              className="d-none d-md-inline ms-2 "
              style={{ fontSize: "14px" }}
            >
              <Clock format="D MMM YYYY" ticking={true} interval={60000} />
            </strong>
            <strong
              className="d-none d-xl-inline ms-2 "
              style={{ fontSize: "14px" }}
            >
              <Clock format="HH:mm:ss" ticking={true} interval={1000} />
            </strong>
          </>
        )}
      </div>

      <div className="menuCon">
        <div className="rightMenu">
          <LeftMenu handleOnClick={handleOnClick} menuItems={menulist} />
        </div>
        <div className="rightMenu"></div>
        <Button className="barsMenu mb-2" type="primary" onClick={showDrawer}>
          {<span className="barsBtn"></span>}
        </Button>
        <Drawer
          title="Menu"
          placement="left"
          closable={false}
          onClose={onClose}
          closeIcon={true}
          open={state.visible}
        >
          <LeftMenu handleOnClick={handleOnClick} menuItems={menulist} />
        </Drawer>
      </div>
    </nav>
  );
};

export default Navbar;

// import { useState, useEffect, useContext } from "react";
// import { Menu } from "antd";
// import {
//   AppstoreOutlined,
//   CoffeeOutlined,
//   LoginOutlined,
//   LogoutOutlined,
//   UserAddOutlined,
//   CarryOutOutlined,
//   TeamOutlined,
// } from "@ant-design/icons";
// // import { Context } from "../context";
// import axios from "axios";
// // import { useRouter } from "next/router";
// import { toast } from "react-toastify";

// const { Item, SubMenu, ItemGroup } = Menu;

// const TopNav = ({user ,loading}) => {
//   const [current, setCurrent] = useState("");

//   // const { state, dispatch } = useContext(Context);
//   // const { user } = state;

//   // const router = useRouter();

//   // useEffect(() => {
//   //   process.browser && setCurrent(window.location.pathname);
//   // }, [process.browser && window.location.pathname]);

//   // const logout = async () => {
//   //   dispatch({ type: "LOGOUT" });
//   //   window.localStorage.removeItem("user");
//   //   const { data } = await axios.get("/api/logout");
//   //   toast(data.message);
//   //   router.push("/login");
//   // };

//   return (
//     <Menu
//       theme="dark"
//       mode="horizontal"
//       selectedKeys={[current]}
//       className="mb-2"
//     >
//       <Item

//         icon={<AppstoreOutlined />}
//       >
//         <a>Test</a>

//       </Item>

//       {/* {user && user.role && user.role.includes("Instructor") ? (
//         <Item
//           key="/instructor/course/create"
//           onClick={(e) => setCurrent(e.key)}
//           icon={<CarryOutOutlined />}
//         >

//         </Item>
//       ) : (
//         <Item
//           key="/user/become-instructor"
//           onClick={(e) => setCurrent(e.key)}
//           icon={<TeamOutlined />}
//         >

//         </Item>
//       )} */}

//       {/* {user === null && (
//         <>
//           <Item
//             className="float-right"
//             key="/register"
//             onClick={(e) => setCurrent(e.key)}
//             icon={<UserAddOutlined />}
//           >
//             <Link href="/register">
//               <a>Register</a>
//             </Link>
//           </Item>

//           <Item
//             className="float-right"
//             key="/login"
//             onClick={(e) => setCurrent(e.key)}
//             icon={<LoginOutlined />}
//           >

//           </Item>
//         </>
//       )} */}

//       {/* {user !== null && (
//         <SubMenu
//           icon={<CoffeeOutlined />}
//           title={user && user.name}
//           className="float-right"
//         >
//           <ItemGroup>
//             <Item key="/user">
//               <Link href="/user">
//                 <a>Dashboard</a>
//               </Link>
//             </Item>
//             <Item onClick={logout}>Logout</Item>
//           </ItemGroup>
//         </SubMenu>
//       )} */}

//       {/* {user && user.role && user.role.includes("Instructor") && (
//         <Item
//           key="/instructor"
//           onClick={(e) => setCurrent(e.key)}
//           icon={<TeamOutlined />}
//           className="float-right"
//         >

//         </Item>
//       )} */}
//     </Menu>
//   );
// };

// export default TopNav;
